module.exports = __webpack_public_path__ + "static/media/OW1@2x.e4a4a16b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/OW/OW1@2x.png
// module id = 717
// module chunks = 0